module.exports = __webpack_public_path__ + "static/media/DrGomare.3d303bde.jpg";